import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=418fcc90"
import script from "./TestPage.vue?vue&type=script&lang=js"
export * from "./TestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports